import { render, staticRenderFns } from "./anexoAto.vue?vue&type=template&id=026950cb&scoped=true"
import script from "./anexoAto.vue?vue&type=script&lang=js"
export * from "./anexoAto.vue?vue&type=script&lang=js"
import style0 from "./anexoAto.vue?vue&type=style&index=0&id=026950cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026950cb",
  null
  
)

export default component.exports